import assetActionService from "../../../../services/assetService/assetActionService/assetActionService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETACTIONS } from "../../../../utils/constants";
import { AssetActionInterface } from "../../../../models/AssetModel/AssetAction/AssetAction";

interface AddAssetActionContext {
  previousAssetActions: AssetActionInterface[];
}

const useAddAssetActions = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    AssetActionInterface,
    Error,
    AssetActionInterface,
    AddAssetActionContext
  >({
    mutationFn: assetActionService.Save,

    onMutate: () => {
      const previousAssetActions =
        queryClient.getQueryData<AssetActionInterface[]>([
          CACHE_KEY_ASSETACTIONS,
          page,
          pageSize,
        ]) || [];

      return { previousAssetActions };
    },

    onSuccess: (savedAssetAction) => {
      console.log("save", savedAssetAction);
      queryClient.setQueryData<AssetActionInterface[]>(
        [CACHE_KEY_ASSETACTIONS, page, pageSize],
        (assetActions) =>
          assetActions
            ? [savedAssetAction, ...assetActions]
            : [savedAssetAction]
      );
    },

    onError: (error, newCategory, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetActionInterface[]>(
        [CACHE_KEY_ASSETACTIONS, page, pageSize],
        context.previousAssetActions
      );
    },
  });
};

export default useAddAssetActions;
